// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-H9K","fullView":"styles_fullView__3PJtV"};